/**
 * زرار «إظهار كلمة السر» جوّه حقل `.input`.
 *
 * 🔴 ليه موجود: أول دفعة من الفريق كانت بتكتب كلمة السر على الموبايل
 *    وهي مش شايفاها، فتغلط في حرف وتترفض — وكل رفض كان بيقرّبها من القفل.
 *
 * ⚠️ `type="button"` إجباري: من غيره الضغطة جوّه الفورم بتبعته.
 * ⚠️ `onMouseDown` بيمنع خروج التركيز من الحقل — الكيبورد على الموبايل
 *    ما يقفلش ويفتح مع كل ضغطة.
 */
import { Icon } from "./Icon";

export function PasswordReveal({
  shown,
  onToggle,
  disabled,
}: {
  shown: boolean;
  onToggle: () => void;
  disabled?: boolean;
}) {
  const label = shown ? "إخفاء كلمة السر" : "إظهار كلمة السر";
  return (
    <button
      type="button"
      className="pw-reveal"
      onClick={onToggle}
      onMouseDown={(e) => e.preventDefault()}
      disabled={disabled}
      aria-label={label}
      aria-pressed={shown}
      title={label}
    >
      <Icon name={shown ? "eye-off" : "eye"} size={18} stroke="#667085" />
    </button>
  );
}
